var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshotMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screenshot_monitor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.0703 110.901V110.401H47.5703H24.237C18.0397 110.401 13.0703 105.376 13.0703 99.2339V29.2339C13.0703 23.035 18.0381 18.0672 24.237 18.0672H117.57C123.712 18.0672 128.737 23.0366 128.737 29.2339V99.2339C128.737 105.374 123.711 110.401 117.57 110.401H94.237H93.737V110.901V122.067H48.0703V110.901ZM117.57 99.7339H118.07V99.2339V29.2339V28.7339H117.57H24.237H23.737V29.2339V99.2339V99.7339H24.237H117.57ZM38.8203 43.3172H38.3203V43.8172V57.9005H30.5703V35.5672H52.9036V43.3172H38.8203ZM102.987 85.1505H103.487V84.6505V70.5672H111.237V92.9005H88.9036V85.1505H102.987Z",
    fill: "#F6E003",
    stroke: "#F6E003"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotMonitor);
export default __webpack_public_path__ + "static/media/screenshot_monitor.1fc0c605664c9d596d1bfe8b1ba8afb3.svg";
export { ForwardRef as ReactComponent };